import React from 'react'
import {
  StyledGroup,
  StyledCheckbox,
} from 'components/UIComponents/FilterCheckBoxComp/style'
import Flex from 'components/Flex'

const FilterCheckBoxComp = ({
  value,
  options,
  onChange,
  padding = '1rem 10px !important',
  valueParam = 'value',
  labelParam = 'label',
  onChangeCheck,
  gap,
  column = 'column',
  margin = 0,
  style,
}) => {
  return (
    <StyledGroup
      value={value}
      onChange={onChange}
      gap={gap}
      margin={margin}
      column={column}
      style={style}
    >
      {options?.map((item, index) => (
        <Flex spaceBetween centerVertically key={item[valueParam]}>
          {item?.[labelParam]?.length > 0 && (
            <StyledCheckbox
              value={item[valueParam]}
              label={item[labelParam]}
              onChange={onChangeCheck}
              padding={padding}
            />
          )}
        </Flex>
      ))}
    </StyledGroup>
  )
}

export default FilterCheckBoxComp
